import React, { useState, useEffect } from 'react';
import {
    Container,
} from '@mui/material';
import AdminMenu from '../../components/menu';
import BoFTitle from '../../components/bof-title';
import NewsForm from '../../components/form/news-form';

export default function NewsAdd() {
    return(
        <>
            <AdminMenu/>
            <Container maxWidth="lg" style={{ marginTop: '7rem' }}>
                <BoFTitle
                    title={"Add News"}
                    is_main_page={false}
                />
                <NewsForm
                    mode={'add'}
                    button_title={'Add'}
                />
            </Container>
        </>
    )
}